import React, { useContext, useRef } from 'react';
import { withTheme } from 'styled-components';

import { Context } from '@store/store';
import useClickOutside from '@utils/useClickOutside';

import {
  StyledSettingsDropdown,
  StyledThemeToggleWrapper,
  ButtonsWrapper,
  LightThemeButton,
  YellowThemeButton,
  GrayThemeButton,
  DarkThemeButton,
  StyledToggleSinglePageModeWrapper,
  PageModeButton,
  StyledDivider,
  StyledPageControlsWrapper,
  StyledRotateButton,
  StyledAdjustByHeightButton,
  StyledAdjustByWidthButton,
  StyledFullscreenStartButton,
} from './settings-dropdown.styles';

const SettingsDropdown = ({ bookId, theme }) => {
  const [state, dispatch] = useContext(Context);
  const wrapperRef = useRef(null);

  useClickOutside(wrapperRef, 'dropdown');

  return (
    <StyledSettingsDropdown
      isOpened={state.isSettingsDropdownOpened}
      data-is-opened={state.isSettingsDropdownOpened}
      ref={wrapperRef}
    >
      <StyledToggleSinglePageModeWrapper>
        <span>Отображение страниц</span>
        <ButtonsWrapper>
          <PageModeButton
            title="Показывать по две страницы"
            onClick={() =>
              dispatch({ type: 'TOGGLE_PAGE_MODE', payload: false })
            }
            active={state.isSinglePageMode === false}
            disabled={!state.isSinglePageMode}
          >
            <svg
              width="26"
              height="22"
              viewBox="0 0 26 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="12"
                height="22"
                fill={theme.themeColors.settingsDropdown.pageModeTogglerColor}
              />
              <rect
                x="14"
                width="12"
                height="22"
                fill={theme.themeColors.settingsDropdown.pageModeTogglerColor}
              />
            </svg>
          </PageModeButton>
          <PageModeButton
            title="Показывать по одной странице"
            onClick={() =>
              dispatch({ type: 'TOGGLE_PAGE_MODE', payload: true })
            }
            active={state.isSinglePageMode === true}
            disabled={state.isSinglePageMode}
          >
            <svg
              width="15"
              height="24"
              viewBox="0 0 15 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                width="15"
                height="24"
                fill={theme.themeColors.settingsDropdown.pageModeTogglerColor}
              />
            </svg>
          </PageModeButton>
        </ButtonsWrapper>
      </StyledToggleSinglePageModeWrapper>
      <StyledDivider />
      <StyledThemeToggleWrapper>
        <span>Цвет фона</span>
        <ButtonsWrapper>
          <LightThemeButton
            active={state.activeTheme === 0}
            onClick={() =>
              dispatch({ type: 'TOGGLE_ACTIVE_THEME', payload: 0 })
            }
            title="Светлая тема"
          />
          <YellowThemeButton
            active={state.activeTheme === 1}
            onClick={() =>
              dispatch({ type: 'TOGGLE_ACTIVE_THEME', payload: 1 })
            }
            title="Жёлтая тема"
          />
          <GrayThemeButton
            active={state.activeTheme === 2}
            onClick={() =>
              dispatch({ type: 'TOGGLE_ACTIVE_THEME', payload: 2 })
            }
            title="Серая тема"
          />
          <DarkThemeButton
            active={state.activeTheme === 3}
            onClick={() =>
              dispatch({ type: 'TOGGLE_ACTIVE_THEME', payload: 3 })
            }
            title="Тёмная тема"
          />
        </ButtonsWrapper>
      </StyledThemeToggleWrapper>
      {/* <StyledPageControlsWrapper>
        <StyledRotateButton>
          <svg
            width="21"
            height="19"
            viewBox="0 0 21 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M19.8849 1.94263V7.60929H14.2183"
              stroke="#979797"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.2034 16.5801C12.6684 17.5999 10.8434 18.0931 9.00359 17.9855C7.16377 17.8779 5.40878 17.1752 4.00307 15.9833C2.59736 14.7915 1.6171 13.1751 1.20999 11.3777C0.802877 9.58023 0.990981 7.69917 1.74596 6.01795C2.50093 4.33673 3.78187 2.94643 5.39575 2.05655C7.00963 1.16667 8.86901 0.82543 10.6937 1.08425C12.5184 1.34307 14.2095 2.18792 15.5123 3.4915L19.8851 7.60927"
              stroke="#979797"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </StyledRotateButton>
        <StyledAdjustByHeightButton>
          <svg
            width="12"
            height="24"
            viewBox="0 0 12 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="0"
              height="0"
              fill="black"
            >
              <rect fill="white" width="0" height="0" />
            </mask>
            <path
              d="M6.16558 0.21967C5.87269 -0.0732233 5.39782 -0.0732233 5.10492 0.21967L0.331953 4.99264C0.0390596 5.28553 0.0390596 5.76041 0.331953 6.0533C0.624846 6.34619 1.09972 6.34619 1.39261 6.0533L5.63525 1.81066L9.87789 6.0533C10.1708 6.34619 10.6457 6.34619 10.9386 6.0533C11.2314 5.76041 11.2314 5.28553 10.9386 4.99264L6.16558 0.21967ZM5.10492 23.7803C5.39782 24.0732 5.87269 24.0732 6.16558 23.7803L10.9386 19.0074C11.2314 18.7145 11.2314 18.2396 10.9386 17.9467C10.6457 17.6538 10.1708 17.6538 9.87789 17.9467L5.63525 22.1893L1.39261 17.9467C1.09972 17.6538 0.624846 17.6538 0.331953 17.9467C0.0390596 18.2396 0.0390596 18.7145 0.331953 19.0074L5.10492 23.7803ZM4.88525 0.75L4.88525 23.25H6.38525L6.38525 0.75L4.88525 0.75Z"
              fill="#979797"
              mask="url(#)"
            />
          </svg>
        </StyledAdjustByHeightButton>
        <StyledAdjustByWidthButton>
          <svg
            width="25"
            height="12"
            viewBox="0 0 25 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="0"
              height="0"
              fill="black"
            >
              <rect fill="white" width="0" height="0" />
            </mask>
            <path
              d="M1.10492 5.15607C0.812031 5.44896 0.812031 5.92384 1.10492 6.21673L5.87789 10.9897C6.17079 11.2826 6.64566 11.2826 6.93855 10.9897C7.23145 10.6968 7.23145 10.2219 6.93855 9.92904L2.69591 5.6864L6.93855 1.44376C7.23145 1.15087 7.23145 0.675994 6.93855 0.383101C6.64566 0.0902071 6.17079 0.0902071 5.87789 0.383101L1.10492 5.15607ZM24.6656 6.21673C24.9585 5.92384 24.9585 5.44896 24.6656 5.15607L19.8926 0.383101C19.5997 0.0902071 19.1248 0.0902071 18.832 0.383101C18.5391 0.675994 18.5391 1.15087 18.832 1.44376L23.0746 5.6864L18.832 9.92904C18.5391 10.2219 18.5391 10.6968 18.832 10.9897C19.1248 11.2826 19.5997 11.2826 19.8926 10.9897L24.6656 6.21673ZM1.63525 6.4364H24.1353V4.9364H1.63525V6.4364Z"
              fill="#979797"
              mask="url(#)"
            />
          </svg>
        </StyledAdjustByWidthButton>
        <StyledFullscreenStartButton>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.4964 27.3632C27.9106 27.3632 28.2464 27.0274 28.2464 26.6132L28.2464 19.8632C28.2464 19.449 27.9106 19.1132 27.4964 19.1132C27.0821 19.1132 26.7464 19.449 26.7464 19.8632V25.8632H20.7464C20.3321 25.8632 19.9964 26.199 19.9964 26.6132C19.9964 27.0274 20.3321 27.3632 20.7464 27.3632L27.4964 27.3632ZM19.895 20.0724L26.966 27.1435L28.0267 26.0829L20.9556 19.0118L19.895 20.0724Z"
              fill="#979797"
            />
            <path
              d="M27.3987 4.24998C27.8129 4.24998 28.1487 4.58576 28.1487 4.99998L28.1487 11.75C28.1487 12.1642 27.8129 12.5 27.3987 12.5C26.9845 12.5 26.6487 12.1642 26.6487 11.75V5.74998H20.6487C20.2345 5.74998 19.8987 5.41419 19.8987 4.99998C19.8987 4.58576 20.2345 4.24998 20.6487 4.24998L27.3987 4.24998ZM19.7973 11.5407L26.8684 4.46965L27.929 5.53031L20.858 12.6014L19.7973 11.5407Z"
              fill="#979797"
            />
            <path
              d="M4.88548 27.3412C4.47126 27.3412 4.13548 27.0054 4.13548 26.5912L4.13548 19.8412C4.13548 19.427 4.47126 19.0912 4.88548 19.0912C5.29969 19.0912 5.63548 19.427 5.63548 19.8412V25.8412H11.6355C12.0497 25.8412 12.3855 26.177 12.3855 26.5912C12.3855 27.0054 12.0497 27.3412 11.6355 27.3412L4.88548 27.3412ZM12.4869 20.0505L5.41581 27.1215L4.35515 26.0609L11.4262 18.9898L12.4869 20.0505Z"
              fill="#979797"
            />
            <path
              d="M5.13548 4.5001C4.72126 4.5001 4.38548 4.83589 4.38548 5.2501L4.38548 12.0001C4.38548 12.4143 4.72126 12.7501 5.13548 12.7501C5.54969 12.7501 5.88548 12.4143 5.88548 12.0001V6.0001H11.8855C12.2997 6.0001 12.6355 5.66431 12.6355 5.2501C12.6355 4.83589 12.2997 4.5001 11.8855 4.5001L5.13548 4.5001ZM12.7369 11.7908L5.66581 4.71977L4.60515 5.78043L11.6762 12.8515L12.7369 11.7908Z"
              fill="#979797"
            />
          </svg>
        </StyledFullscreenStartButton>
      </StyledPageControlsWrapper> */}
    </StyledSettingsDropdown>
  );
};

export default withTheme(SettingsDropdown);
